import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { refreshProductList } from "../../../../redux/features/productModalSlice";
import { AddProduct } from "../../../../redux/services/ProductService/product.Services";
import { successToast, errorToast } from "../../../../Utils/toast";
import { ActiveUserList } from "../../../../redux/services/User Services/User.Services";
import useDropdownData from "./hooks/useDropdownData";
import useProductForm from "./hooks/useProductForm";
import useProductConfiguration from "./hooks/useProductConfiguration";

import ProductFormRenderer from "./ProductFormRenderer";

function CreateProduct({ refreshData }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const form = useProductForm();
    const dropdown = useDropdownData();
    // const config = useProductConfiguration();
    const config = useProductConfiguration(form.formData.subcategory_slug);

    // const config = useProductConfiguration(
    //     form.formData.subcategory_id
    // );
    const admin = useSelector((state) => state.auth.admin);
    const userInfo = admin?.subcategory?.slug || admin?.subcategory?.name || 'Unknown';
    const handleSubmit = async (e) => {
        e.preventDefault();
        const isValid = form.validate();
    
    if (!isValid) {
        console.log("❌ Validation Failed - Errors:", form.errors);
        
        // ✅ Show specific error messages
        const errorMessages = Object.values(form.errors);
        if (errorMessages.length > 0) {
            errorToast(`Please fix: ${errorMessages.join(", ")}`);
        }
        return;
    }

        try {
            form.setIsLoading(true);
            const payload = form.createFormData();
            // for (const pair of payload.entries()) {
            //     console.log(pair[0], pair[1]);
            // }
            const res = await AddProduct(payload);
            if (res?.data?.success) {
                successToast(res.data.message);
                refreshData?.();
                dispatch(refreshProductList());
                navigate("/product-list");
            } else {
                errorToast(res?.data?.message);
            }

        } catch (error) {

            console.log(error);

            errorToast("Failed to create product");

        } finally {

            form.setIsLoading(false);

        }
    };

    const selectedUser = dropdown.users?.find(
        (user) => user.id === Number(form.formData.user_id)
    );

    return (
        <div className="main_page">
            <div className="">
                <div className="">
                    <div className="d-flex justify-content-between mb-3">
                        <h4>Add Product</h4>
                        {/* MODIFY THIS SECTION - Add user info */}
                        <div className="d-flex align-items-center gap-3">


                            <button
                                className="add-btn"
                                onClick={() => navigate(-1)}
                            >
                                Back
                            </button>
                            {/* <button className="add-btn">
                                {selectedUser
                                    ? `${selectedUser.name} `
                                    : "Select User"}
                            </button> */}
                        </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="">
                            <ProductFormRenderer
                                form={form}
                                users={dropdown.users}
                                dropdown={dropdown}
                                config={config}
                            />

                            <div className="col-md-12">
                                <div className="d-flex justify-content-end gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={form.isLoading}
                                    >
                                        {form.isLoading ? "Creating..." : "Create Product"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default CreateProduct;